<template>
  <div>
    <div class="header">
      <img class="go_back" src="@/assets/return.png" alt @click="go_back()">
      <h2 class="title">专题推荐</h2>
    </div>
    <div class="banner_img">
      <img :src="banner.banner" alt="">
      <div class="mask">
        <img src="@/assets/mask.png" alt="">
      </div>
    </div>
    <div class="main">
      <div class="total_box">
        <div class="list">
          <div class="item">
            <span class="number">{{ lesson_count }}</span>
            <span class="text">课程</span>
          </div>
          <div class="item">
            <span class="number">{{ collection_count }}</span>
            <span class="text">人收藏</span>
          </div>
          <div class="item">
            <span class="number">{{ learn_count }}</span>
            <span class="text">人学习</span>
          </div>
        </div>
        <!--  uncollect 未收藏  collected 已收藏  -->
        <div class="collect_box" :class="is_collection==0?'uncollect':'collected'" @click="collect">
          <img v-if="is_collection==0" src="@/assets/img/uncollect.png" alt="">
          <img v-if="is_collection==1" src="@/assets/img/collected.png" alt="">
          <span class="collect_txt">{{ is_collection==0?'收藏':'已收藏' }}</span>
          <span class="collect_num">{{ collection_count }}</span>
        </div>
      </div>
      <div v-if="lessonList && lessonList.length>0">
        <div class="free_head">
          <div class="main_title">VIP免费课程</div>
        </div>
        <div v-for="(i,v) in lessonList" :key="v" class="main_content">
          <div class="main_content_top" @click="toDetails(i)">
            <div v-if="v<3" class="hot_lesson">
              HOT
            </div>
            <img :src="i.logo" alt="">
            <div class="main_content_ps">
              <p>{{ i.title }}</p>
              <p>{{ i.description }}</p>
            </div>
          </div>
          <!-- <div class="main_content_bottom">
            <div class="vip_text" @click="toPay">
              <p>升级VIP免费</p>
              <p>￥{{ i.price }}&nbsp;</p>
            </div>
          </div> -->
        </div>
      </div>
      <div v-if="threadList && threadList.length>0" class="flex_box">
        <div class="free_head">
          <div class="main_title">免费资料</div>
          <div class="title_right" @click="toDown">更多免费资料 ></div>
        </div>
        <div class="box_flex">
          <div v-for="(i,v) in threadList" :key="v" class="free_down" @click="toDetails(i,true)">
            <img :src="i.logo" alt="">
            <div>
              <p class="free_down_title">{{ i.title }}</p>
              <div class="down_info">
                <p class="imgText">
                  <img src="@/assets/look.png" alt="">
                  <span> {{ i.view_num }}</span>
                </p>
                <p class="imgText">
                  <img src="@/assets/pinglun.png" alt="">
                  <span> {{ i.reply_num }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="vip_btn" @click="toPay">
            <img src="@/assets/upvip2.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="discountList && discountList.length>0" class="flex_box">
        <div class="free_head">
          <div class="main_title">折扣课程</div>
          <div class="title_right" @click="toLesson">更多折扣课程 ></div>
        </div>
        <div class="box_flex">
          <div v-for="(i,v) in discountList" :key="v" class="free_lesson" @click="toDetails(i)">
            <div class="lesson_top">
              <img :src="i.logo" alt="">
              <div class="free_lesson_ps">
                <p class="ps_left">
                  <img src="@/assets/time90.png" alt="">
                  <span>{{ i.time }}分钟</span>
                </p>
                <p class="ps_left">
                  <img src="@/assets/people90.png" alt="">
                  <span>{{ i.student }}人</span>
                </p>
              </div>
            </div>
            <div class="lesson_bottom">
              <p class="lesson_bottom_top">{{ i.title }}</p>
              <div class="lesson_bottom_bottom">
                <p>￥{{ i.price }}&nbsp;</p>
                <p v-if="String(i.money).indexOf('.') == -1">折后 ￥<span class="big">{{ i.money }}</span></p>
                <p v-else>折后 ￥<span class="big">{{ String(i.money).split('.')[0] }}</span>.{{ String(i.money).split('.')[1] }}</p>
              </div>
            </div>
          </div>

          <div class="vip_btn" @click="toPay">
            <img src="@/assets/upvip2.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail, getFreeLesson, getFreeThread, getDiscountLesson, saveVipCardCollection } from '@/api/vipList.js'
import tool from '@/utils/tools.js'
export default {
  components: {
  },
  data() {
    return {
      id: this.$route.query.id || '',
      banner_arr: [],
      banner: {},
      lessonList: [],
      threadList: [],
      discountList: [],
      is_collection: 0, // 是否收藏
      lesson_count: 0,
      collection_count: 0,
      learn_count: 0
    }
  },
  mounted() {
    this.getDetail()
    this.getFreeLesson()
    this.getFreeThread()
    this.getDiscountLesson()
  },
  methods: {
    // 收藏
    collect() {
      var info = {
        special_page_id: this.id,
        type: ''
      }
      if (this.is_collection == 0) {
        info.type = 1
      } else {
        info.type = 0
      }
      saveVipCardCollection(info).then((res) => {
        if (res.errNo == 0) {
          console.log(res)
          this.getDetail()
        }
      })
    },
    // 专题页面详情
    getDetail() {
      const info = {
        id: this.id
      }
      getDetail(info).then(res => {
        console.log(res, 'res')
        this.banner = res.result
        const my_title = document.getElementsByTagName('title')[0]
        my_title.innerHTML = res.result.name
        // 设置关键词
        const my_keys = document.getElementsByName('keywords')[0]
        my_keys.content = res.result.keyword
        // 设置描述
        const my_description = document.getElementsByName('description')[0]
        my_description.content = res.result.description
        this.is_collection = res.result.is_collection
        this.lesson_count = res.result.lesson_count
        this.collection_count = res.result.collection_count
        this.learn_count = res.result.learn_count
      })
    },
    // 专题页面免费课程
    getFreeLesson() {
      const info = {
        id: this.id
      }
      getFreeLesson(info).then(res => {
        console.log(res, 'res')
        if (res.errNo === 0) {
          this.lessonList = res.result.list
        }
      })
    },
    // 专题页面免费资料
    getFreeThread() {
      const info = {
        id: this.id
      }
      getFreeThread(info).then(res => {
        console.log(res, 'res')
        if (res.errNo === 0) {
          this.threadList = res.result.list
        }
      })
    },
    // 专题页面折扣课程
    getDiscountLesson() {
      const info = {
        id: this.id
      }
      getDiscountLesson(info).then(res => {
        if (res.errNo === 0) {
          this.discountList = res.result.list
        }
      })
    },
    // 返回
    go_back() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp'
            , '支付页返回'
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.go(-1)
      }
    },
    // 去详情页
    toDetails(item,isbbs=false) {
      if(isbbs){
        window.location.href = '/bbsgroup/d/'+item.id+'.html'
      }else{
        window.location.href = '/home?lesson_id='+item.id
      }
    },
    // 去支付
    toPay() {
      console.log(location.href)
      var url = window.location.href
      window.location.href = `https://m.zhulong.com/pay/buyMember?product_type=3&fromurl=${url}`
    },
    // 去资料页面
    toDown() {
      window.location.href = '/bbs/down'
    },
    toLesson() {
      window.location.href = '/edu'
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
  width: 100%;
  height: 70px;
  position: fixed;
  top: 0;
  background: #fff;
  z-index: 1;
  display: flex;
  align-items: center;
}
.go_back{
  width: 20.5px;
  height: 36px;
  position: absolute;
  left: 38px;
}
.title{
  height: 70px;
  line-height: 70px;
  margin: 0 auto;
}
.banner_img{
  margin-top: 71px;
  width: 100%;
  height: 377px;
  position: relative;
  text-align: center;
  overflow: hidden;
  >img{
    // width: 100%;
    height: 100%;
    margin: 0 -25%;
  }
  .mask{
    position: absolute;
    bottom: -8px;
    width: 100%;
    img{
      width: 100%;
    }
  }
}
.main{
  background: url('../../assets/backgroundL.png') no-repeat;
  margin-top: -8px;
  .total_box{
      // width: 1210px;
      height: 100px;
      background: #454340;
      // position: absolute;
      // top: -100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      .list{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .item{
        margin-right: 20px;
        .number{
          height: 47px;
          font-family: DINAlternate-Bold;
          font-size: 28px;
          color: #F6D69D;
          letter-spacing: 0;
          font-weight: 400;
          margin-right: 8px;
        }
        .text{
          height: 25px;
          font-family: PingFangSC-Regular;
          font-size: 28px;
          color: rgba(255,255,255,0.90);
          letter-spacing: 0;
          font-weight: 400;
        }
      }
      .uncollect{
        background: rgba(255,255,255,0.80);
        color: #333333;
      }
      .collected{
        background-image: linear-gradient(136deg, #F8DAA5 0%, #EBBE6F 100%);
        color: #956015;
      }
      .collect_box{
          height: 64px;
          border-radius: 32px;
          display: flex;
          align-items: center;
          padding: 0 20px;
          cursor: pointer;
          img{
            width: 28px;
            height: 28px;
            margin-right: 8px;
          }
          .collect_txt,.collect_num{
            // height: 25px;
            font-family: PingFangSC-Medium;
            font-size: 28px;
            letter-spacing: 0;
            font-weight: 600;
          }
          .collect_txt{
            margin-right: 8px;
          }
        }
    }
  .free_head{
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .main_title{
      height: 100px;
      line-height: 100px;
      font-family: PingFangSC-Medium;
      font-size: 32px;
      color: rgba(255,255,255,0.90);
      letter-spacing: 0;
      font-weight: 500;
    }
    .title_right{
      // font-family: PingFangSC-Regular;
      font-size: 26px;
      color: rgba(255,255,255,0.60);
      letter-spacing: 0;
      font-weight: 400;
    }
  }
  .main_content{
    width: 690px;
    // height: 640px;
    height: 520px;
    margin: 0 auto 30px;
    .main_content_top{
      width: 100%;
      height: 518px;
      position: relative;
      .hot_lesson{
        width: 78px;
        height: 38px;
        line-height: 38px;
        text-align:center;
        position:absolute;
        top:0px;
        left:0px;
        color:#fff;
        font-size:24px;
        background: url('../../assets/img/hot_bg.png') no-repeat;
        background-size: cover;
      }
      img{
        width: 100%;
      }
      .main_content_ps{
        width: calc(100% - 40px);
        height: 100px;
        position: absolute;
        bottom: 0;
        padding: 10px 20px;
        background: rgba(52,52,52,0.86);
        display: flex;
        flex-flow: wrap;
        align-items: center;
        p{
          // font-family: PingFangSC-Regular;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          letter-spacing: 0;
        }
        p:first-child{
          font-size: 32px;
          color: rgba(255,255,255,0.90);
          font-weight: 500;
        }
        p:last-child{
          font-size: 28px;
          color: rgba(255,255,255,0.70);
          font-weight: 400;
        }
      }
    }
    .main_content_bottom{
      height: 120px;
      background: #343434;
      display: flex;
      align-items: center;
      .vip_text{
        width: 650px;
        height: 86px;
        background: url('../../assets/upvip.png') round;
        margin: 0 auto;
        p{
          text-align: center;
        }
        p:first-child{
          font-family: PingFangSC-Medium;
          font-size: 32px;
          color: #824D01;
          letter-spacing: 0;
          font-weight: 500;
          margin-top: 6px;
        }
        p:last-child{
          font-family: PingFangSC-Regular;
          font-size: 24px;
          color: rgba(130,77,1,0.80);
          letter-spacing: 0;
          font-weight: 400;
          text-decoration:line-through;
        }
      }
    }
  }
  .free_down{
    width: 337px;
    background: #444340;
    box-shadow: 0px 0px 26px 0px rgba(0,0,0,0.1);
    margin-bottom: 20px;
    >img{
      width: 100%;
    }
    .free_down_title{
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      padding: 10px 16px;
      font-family: PingFangSC-Medium;
      font-size: 26px;
      color: rgba(255,255,255,0.90);
      letter-spacing: 0;
      font-weight: 500;
    }
    .down_info{
      display: flex;
      justify-content: space-between;
      padding: 0 16px 10px;
      font-family: PingFangSC-Regular;
      font-size: 20px;
      color: rgba(255,255,255,0.60);
      letter-spacing: 0;
      font-weight: 400;
      .imgText{
        display: flex;
        align-items: center;
        img{
          margin-right: 6px;
          width: 28px;
        }
      }
    }
  }
  .free_lesson{
    width: 337px;
    margin-bottom: 20px;
    .lesson_top{
      position: relative;
      >img{
        width: 100%;
      }
      .free_lesson_ps{
        width: calc(100% - 40px);
        height: 66.6px;
        position: absolute;
        display: flex;
        justify-content: space-between;
        bottom: 0;
        padding: 0 20px;
        background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.80) 100%);
        .ps_left{
          display: flex;
          align-items: center;
          font-family: PingFangSC-Regular;
          font-size: 20px;
          color: #FFFFFF;
          letter-spacing: 0;
          font-weight: 400;
          >img{
            width: 24px;
            height: 24px;
            margin-right: 6px;
          }
        }
      }
    }
    .lesson_bottom{
      width: 100%;
      height: 148px;
      background: #343434;
      border: 0;
      display: flex;
      flex-flow: column;
      .lesson_bottom_top{
        font-family: PingFangSC-Regular;
        font-size: 26px;
        color: rgba(255,255,255,0.90);
        letter-spacing: 0;
        line-height: 34px;
        font-weight: 400;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        padding: 10px 16px;
      }
      .lesson_bottom_bottom{
        width: calc(100% - 40px);
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        align-items: center;
        p:first-child{
          font-family: PingFangSC-Regular;
          font-size: 22px;
          color: rgba(255,255,255,0.60);
          letter-spacing: 0;
          margin-top: 8px;
          font-weight: 400;
          text-decoration:line-through;
        }
        p:last-child{
          font-family: PingFangSC-Regular;
          font-size: 22px;
          color: #ECC175;
          letter-spacing: 0;
          font-weight: 500;
          .big{
            font-size: 36px;
          }
        }
      }
    }
  }
}
.box_flex{
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  padding: 0 30px;
}
.vip_btn{
  width: 440px;
  margin: 30px auto 50px;
  img{
    width: 100%;
  }
}
img{
  display: block;
}
</style>
